import React from 'react';
import { Paper, Grid, Typography, Box, TextField, Button, IconButton, Collapse, InputAdornment, MenuItem } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { PAUSE_OPTIONS, DEPLACEMENT_OPTIONS, timeToMinutes, depBrutHeures } from '../../../utils/releveHeures';

// Carte d'un jour de la semaine : en-tête pliable + champs (début/fin/pause/déplacement/observations)
export default function DayCard({
    classes, isMobile, jour, data, totalJour, isLocked, isExpanded,
    onToggleExpand, onApplyJourneeType, onOpenClockPicker,
    onPauseChange, onDepChange, onObsChange, onValiderObservation
}) {
    const jourKey = jour.toLowerCase();
    const depHeures = depBrutHeures(data.depBrut);

    return (
        <Paper className={classes.dayCard}>
            <div
                className={classes.dayHeader}
                onClick={() => !isLocked && onToggleExpand()}
                style={{
                    cursor: isLocked ? 'default' : 'pointer',
                    flexDirection: isMobile ? 'column' : 'row',
                    textAlign: isMobile ? 'center' : 'left',
                    gap: isMobile ? 8 : 0
                }}
            >
                <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} alignItems="center" gap={1}>
                    <Typography variant="h6" style={{ fontWeight: 700, color: '#1a202c' }}>
                        {jour}
                    </Typography>
                    {data.debut && data.fin && (
                        <Typography variant="caption" color="textSecondary" style={{ marginLeft: isMobile ? 0 : 8, fontWeight: 500 }}>
                            {data.debut} → {data.fin}
                        </Typography>
                    )}
                </Box>

                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                    {timeToMinutes(data.depBrut) > 0 && (
                        <Box display="flex" alignItems="center" gap={0.5} style={{ backgroundColor: '#edf2f7', fontWeight: 600, padding: '4px 10px', borderRadius: 16, fontSize: '0.75rem' }}>
                            <DriveEtaIcon style={{ fontSize: 14 }} /> {`${depHeures}h trajet`}
                        </Box>
                    )}

                    <span className={classes.totalBadge}>
                        {`${totalJour} h`}
                    </span>

                    {!isLocked && (
                        <IconButton size="small">
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    )}
                </Box>
            </div>

            <Collapse in={isExpanded}>
                <Box className={classes.dayBody}>
                    {!isLocked && (
                        <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} mb={2}>
                            <Button
                                size="small"
                                startIcon={<FlashOnIcon style={{ fontSize: 16 }} />}
                                onClick={onApplyJourneeType}
                                style={{ textTransform: 'none', color: '#2b6cb0', fontWeight: 600 }}
                            >
                                Journée type (8h)
                            </Button>
                        </Box>
                    )}

                    <Grid container spacing={2} justify={isMobile ? 'center' : 'flex-start'}>
                        <Grid item xs={6} sm={3}>
                            <TextField
                                type="text"
                                label="Début"
                                placeholder="--:--"
                                value={data.debut}
                                onClick={() => onOpenClockPicker('debut')}
                                readOnly
                                variant="outlined"
                                fullWidth
                                disabled={isLocked}
                                className={classes.formInputEqual}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end"><AccessTimeIcon fontSize="small" color="action" /></InputAdornment>
                                }}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <TextField
                                type="text"
                                label="Fin"
                                placeholder="--:--"
                                value={data.fin}
                                onClick={() => onOpenClockPicker('fin')}
                                readOnly
                                variant="outlined"
                                fullWidth
                                disabled={isLocked}
                                className={classes.formInputEqual}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end"><AccessTimeIcon fontSize="small" color="action" /></InputAdornment>
                                }}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <TextField
                                id={`pause-${jourKey}`}
                                select
                                label="Pause"
                                value={data.pause}
                                onChange={e => onPauseChange(e.target.value)}
                                variant="outlined"
                                fullWidth
                                disabled={isLocked}
                                className={classes.formInputEqual}
                                InputLabelProps={{ shrink: true }}
                            >
                                {PAUSE_OPTIONS.map(opt => (
                                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <TextField
                                id={`dep-${jourKey}`}
                                select
                                label="Déplacement"
                                value={data.depBrut}
                                onChange={e => onDepChange(e.target.value)}
                                variant="outlined"
                                fullWidth
                                disabled={isLocked}
                                className={classes.formInputEqual}
                                InputLabelProps={{ shrink: true }}
                            >
                                {DEPLACEMENT_OPTIONS.map(opt => (
                                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Box mt={2}>
                        <TextField
                            id={`obs-${jourKey}`}
                            label="Observations (Client,précision...)"
                            value={data.obs}
                            onChange={e => onObsChange(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    onValiderObservation();
                                }
                            }}
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isLocked}
                            className={classes.inputRounded}
                            InputProps={{
                                endAdornment: !isLocked && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onValiderObservation();
                                            }}
                                            title="Valider et passer au champ suivant"
                                        >
                                            <ArrowForwardIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>
                </Box>
            </Collapse>
        </Paper>
    );
}
